<template>
    <div class="card card-body p-5 text-dark user-select-none shadow">
        <div class="d-flex flex-row">
            <div class="flex-grow-1">{{ title || __('general.progress') }}</div>
            <div class="opacity-75">{{ at }} {{ __('general.of') }} {{ total }}</div>
        </div>

        <div class="progress mt-3" :style="`height: ${height};`">
            <div class="progress-bar"
                 :class="{'bg-success': at === total}"
                 role="progressbar"
                 :style="`width: ${percent}%;`"
                 :aria-valuenow="at"
                 :aria-valuemax="total"
                 aria-valuemin="0"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null,
        },
        at: {
            type: Number,
            default: 1,
        },
        total: {
            type: Number,
            default: 1,
        },
        height: {
            type: String,
            default: '.5em',
        },
    },

    computed: {
        percent() {
            if (this.total === 0) {
                return 0
            }

            return (this.at * 100 / this.total).toFixed(2)
        },
    },
}
</script>
